	/* ================================================================
   addons.js — Product Addon ATC Handler
   Built from Shopify AJAX Cart API + Section Rendering API research

   Strategy:
   1. Override Dawn's product-form custom element handler (primary)
   2. Capture-phase submit + click listener as fallback
   3. Build items[] array: main product + checked addons
   4. POST to /cart/add.js with sections for drawer HTML update
   5. Call renderContents(data) for Dawn → CustomEvent fallbacks
      for Impulse / Horizon / others → redirect as last resort
   ================================================================ */

(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
    ? window.Shopify.routes.root : '/';

  /* Section IDs Dawn / most themes use for cart drawer and count bubble */
  var SECTIONS = ['cart-drawer', 'cart-icon-bubble'];

  var isSubmitting = false;

  /* ----------------------------------------------------------------
     Qty +/- buttons (delegated, works for dynamically added rows)
  ---------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('.addon_qty_btn');
    if (!btn) return;
    var input = btn.parentElement.querySelector('.addon_qty_input');
    if (!input) return;
    var val = parseInt(input.value) || 1;
    var max = parseInt(input.getAttribute('max')) || 10;
    if (btn.classList.contains('plus')  && val < max) input.value = val + 1;
    if (btn.classList.contains('minus') && val > 1)   input.value = val - 1;
  });

  /* ----------------------------------------------------------------
     Collect all checked addon items from the page
  ---------------------------------------------------------------- */
  function getAddonItems() {
    var items = [];
    document.querySelectorAll('.addon_checkbox:checked').forEach(function (cb) {
      var id = parseInt(cb.value);
      if (!id) return;
      var row   = cb.closest('.addon_item');
      var qtyEl = row ? row.querySelector('.addon_qty_input') : null;
      var qty   = qtyEl ? (parseInt(qtyEl.value) || 1) : 1;
      items.push({
        id: id,
        quantity: qty,
        properties: { '_addon': 'true' }   /* underscore = hidden at checkout */
      });
    });
    return items;
  }

  /* ----------------------------------------------------------------
     Parse section HTML (same approach Dawn uses internally)
  ---------------------------------------------------------------- */
  function getSectionInnerHTML(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el  = selector ? doc.querySelector(selector) : null;
    if (el) return el.innerHTML;
    var section = doc.querySelector('.shopify-section');
    return section ? section.innerHTML : html;
  }

  /* ----------------------------------------------------------------
     Update cart drawer + count bubble from section rendering response
  ---------------------------------------------------------------- */
  function updateCartSections(sections) {
    if (!sections) return;

    /* Header cart count bubble */
    if (sections['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble) {
        bubble.innerHTML = getSectionInnerHTML(sections['cart-icon-bubble']);
      }
    }

    /* Cart drawer inner content */
    if (sections['cart-drawer']) {
      var drawer = document.getElementById('cart-drawer');
      if (drawer) {
        var inner = drawer.querySelector('.drawer__inner')
                 || drawer.querySelector('.cart-drawer__inner')
                 || drawer.querySelector('[class*="drawer__inner"]');

        if (inner) {
          var parsed = getSectionInnerHTML(
            sections['cart-drawer'],
            '.drawer__inner, .cart-drawer__inner'
          ) || getSectionInnerHTML(sections['cart-drawer']);
          if (parsed) inner.innerHTML = parsed;
        } else {
          var full = getSectionInnerHTML(sections['cart-drawer']);
          if (full) drawer.innerHTML = full;
        }
      }
    }
  }

  /* ----------------------------------------------------------------
     Open cart drawer — full theme cascade
  ---------------------------------------------------------------- */
  function openCartDrawer(data) {

    /* Dawn / Spotlight / Trade — renderContents is the canonical method */
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      cartDrawer.classList.remove('is-empty');
      if (typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(data);
        return;
      }
      if (typeof cartDrawer.open === 'function') {
        cartDrawer.open();
        return;
      }
    }

    /* Dawn cart-notification variant */
    var cartNotif = document.querySelector('cart-notification');
    if (cartNotif && typeof cartNotif.renderContents === 'function') {
      cartNotif.renderContents(data);
      return;
    }

    /* Impulse / Expanse / Streamline */
    try { document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true })); } catch (e) {}

    /* Horizon 2025 */
    try {
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { data: { itemCount: 1, source: 'product-form-component' } }
      }));
    } catch (e) {}

    /* Prestige / Focal / Warehouse */
    try {
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', { bubbles: true })
      );
    } catch (e) {}

    /* Generic class toggle for any remaining themes */
    var opened = false;
    [
      'cart-drawer', '.cart-drawer', '#CartDrawer', '#cart-drawer',
      '.ajaxcart', '.ajax-cart', '.side-cart', '.sidebar-cart',
      '[data-cart-drawer]', '.js-cart-drawer', '.cart__drawer'
    ].forEach(function (sel) {
      if (opened) return;
      var el = document.querySelector(sel);
      if (!el) return;
      el.classList.add('active', 'open', 'is-open', 'is-visible');
      el.removeAttribute('hidden');
      el.setAttribute('open', '');
      document.body.classList.add('cart-is-open', 'cart-open', 'drawer-open');
      opened = true;
    });

    /* Header cart button click fallback */
    if (!opened) {
      var toggle = document.querySelector(
        '[data-cart-toggle], .js-drawer-open-cart, ' +
        '[aria-controls="cart-drawer"], [href="#CartDrawer"], ' +
        '.header__cart-btn, [data-cart]'
      );
      if (toggle) { toggle.click(); opened = true; }
    }

    /* Absolute last resort */
    if (!opened) window.location.href = ROOT + 'cart';
  }

  /* ----------------------------------------------------------------
     Fast count update from cart.js (parallel to section rendering)
  ---------------------------------------------------------------- */
  function updateCartCount() {
    fetch(ROOT + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart.item_count;
        [
          '.cart-count', '#cart-count', '.js-cart-count',
          '[data-cart-count]', '.cart__count',
          '.header__cart-count', '.cart-count-bubble span'
        ].forEach(function (sel) {
          document.querySelectorAll(sel).forEach(function (el) {
            el.textContent = count;
          });
        });
      }).catch(function () {});
  }

  /* ----------------------------------------------------------------
     Button lock / unlock helpers
  ---------------------------------------------------------------- */
  function lockBtn(btn) {
    if (!btn) return;
    btn.setAttribute('aria-disabled', 'true');
    btn.setAttribute('disabled', 'disabled');
    btn.classList.add('loading');
  }

  function unlockBtn(btn) {
    if (!btn) return;
    btn.removeAttribute('aria-disabled');
    btn.removeAttribute('disabled');
    btn.classList.remove('loading');
  }

  /* ----------------------------------------------------------------
     Core ATC handler
     Called from both strategy 1 (overridden product-form handler)
     and strategy 2 (capture-phase submit/click listener)
  ---------------------------------------------------------------- */
  function handleAtc(evt) {
    var addonItems = getAddonItems();

    /* No addons checked — let the theme handle normally */
    if (addonItems.length === 0) return;

    evt.preventDefault();
    evt.stopPropagation();
    evt.stopImmediatePropagation();

    if (isSubmitting) return;
    isSubmitting = true;

    /* Find the form */
    var form = document.querySelector('form[data-type="add-to-cart-form"]')
            || document.querySelector('product-form form')
            || document.querySelector('form[action$="/cart/add"]');

    if (!form) {
      isSubmitting = false;
      window.location.href = ROOT + 'cart';
      return;
    }

    var submitBtn = form.querySelector('[name="add"]')
                 || form.querySelector('[type="submit"]');

    lockBtn(submitBtn);

    /* Read main variant id + quantity from the form */
    var idInput  = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');

    if (!idInput || !parseInt(idInput.value)) {
      unlockBtn(submitBtn);
      isSubmitting = false;
      return;
    }

    var mainId  = parseInt(idInput.value);
    var mainQty = qtyInput ? (parseInt(qtyInput.value) || 1) : 1;

    /* Final items array — main product first, then addons */
    var allItems = [{ id: mainId, quantity: mainQty }].concat(addonItems);

    /* POST — MUST use JSON, not FormData, for multi-item items[] */
    fetch(ROOT + 'cart/add.js', {
      method:  'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept':       'application/json'
      },
      body: JSON.stringify({
        items:        allItems,
        sections:     SECTIONS.join(','),
        sections_url: window.location.pathname
      })
    })
    .then(function (res) {
      /* Read raw text first — never silently swallow Shopify error bodies */
      return res.text().then(function (text) {
        var data = {};
        try { data = JSON.parse(text); } catch (e) {}
        return { ok: res.ok, status: res.status, data: data };
      });
    })
    .then(function (result) {
      unlockBtn(submitBtn);
      isSubmitting = false;

      if (result.ok && result.data && result.data.items) {
        /* Success */
        updateCartSections(result.data.sections);
        updateCartCount();
        openCartDrawer(result.data);
      } else {
        /* 422 or other Shopify cart error */
        var msg = (result.data && (result.data.description || result.data.message))
                  || 'Could not add to cart. Please try again.';
        console.error('[Addons] Cart error:', result.data);
        alert(msg);
      }
    })
    .catch(function (err) {
      console.error('[Addons] Fetch failed:', err);
      unlockBtn(submitBtn);
      isSubmitting = false;
      window.location.href = ROOT + 'cart';
    });
  }

  /* ----------------------------------------------------------------
     Init — attach using BOTH strategies for maximum coverage
  ---------------------------------------------------------------- */
  function init() {

    /* Strategy 1: Override Dawn's product-form custom element handler
       This is the most reliable for Dawn because it runs BEFORE
       Dawn's own submit handler processes the event */
    var productFormEl = document.querySelector('product-form');
    if (productFormEl && typeof productFormEl.onSubmitHandler !== 'undefined') {
      var originalHandler = productFormEl.onSubmitHandler.bind(productFormEl);
      productFormEl.onSubmitHandler = function (evt) {
        if (getAddonItems().length > 0) {
          handleAtc(evt);     /* our handler takes over */
        } else {
          originalHandler(evt);  /* no addons → Dawn does its thing */
        }
      };
    }

    /* Strategy 2: Capture-phase listeners
       capture:true means these fire BEFORE any bubble-phase listeners,
       including Dawn's <product-form> connectedCallback listeners */
    var form = document.querySelector('form[data-type="add-to-cart-form"]')
            || document.querySelector('product-form form')
            || document.querySelector('form[action$="/cart/add"]');

    if (!form) {
      /* Form not in DOM yet — retry */
      setTimeout(init, 400);
      return;
    }

    form.addEventListener('submit', handleAtc, true);

    var submitBtn = form.querySelector('[name="add"]')
                 || form.querySelector('[type="submit"]');

    if (submitBtn) {
      submitBtn.addEventListener('click', function (e) {
        if (getAddonItems().length > 0) handleAtc(e);
      }, true);
    }
  }

  /* ----------------------------------------------------------------
     Boot
  ---------------------------------------------------------------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();